import LegalLayout, { LegalSection, LegalList } from "../../components/chalk/LegalLayout";

export default function AiDisclaimer() {
  return (
    <LegalLayout title="AI Disclaimer" eyebrow="Legal" lastUpdated="February 2026" testId="page-ai-disclaimer">
      <LegalSection heading="What our AI does">
        <p>
          Chalk OS includes AI-powered features — including Draw It Up and Erase and Redraw — that
          generate text suggestions to help coaches communicate with their teams faster. The AI
          drafts a message; the coach decides what to send.
        </p>
      </LegalSection>

      <LegalSection heading="What the AI is not">
        <p>
          AI features provide writing assistance only. AI output may be incomplete or inaccurate.
          Coaches must review all AI-generated content before sending it. AI suggestions are not
          medical, legal, transportation, weather, safety, scheduling, or eligibility advice.
        </p>
      </LegalSection>

      <LegalSection heading="Coach responsibility">
        <LegalList items={[
          "Review every AI-generated draft before sending it to families or athletes.",
          "Verify schedule, location, time, weather, and safety information independently.",
          "Do not rely on AI suggestions for emergency communication.",
          "Edit drafts so the message accurately reflects your decision and your team's situation.",
        ]} />
      </LegalSection>

      <LegalSection heading="Data sent to AI providers">
        <p>
          Generating a draft sends the prompt information you provided (for example, the topic, tone,
          and event details) to a third-party AI provider for the sole purpose of producing the
          draft. We do not send athlete medical notes, guardian contact details, or other restricted
          fields to AI providers. AI providers are contractually bound not to use submitted prompts
          to train their public models.
        </p>
      </LegalSection>

      <LegalSection heading="Limitations and changes">
        <p>
          AI behavior, available models, and feature scope may change as we improve the product.
          Chalk OS does not guarantee any specific AI output, model availability, or response time.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
